<template>
  <div class="coreProductInfo">
    <img src="/status/hexincanping.jpg" style="width: 100%">
    <div class="box_middle_list">
      <div class="core_top" >
        <span @click="black" style="cursor: pointer">返回上一页</span>
      </div>
      <div class="list_list">
        <div class="list_left">
          <el-image class="list_left-img" :src="list.img" fit = 'contain' />
          <el-image
              class="imgInfo" v-if="list.imgInfo" :src="list.imgInfo"
              fit = 'contain'
              >
          </el-image>
        </div>
        <div class="list_right">
          <div class="name">{{list.name}}</div>
          <div class="info">产品介绍：
            <div style="margin-top: 10px" v-html="list.info"></div></div>
          <div class="btn_list">
            <div class="phone">
              <img src="/status/dianhua.png">
              <div>400-022-9558</div>
            </div>
            <div class="sub">联系我们</div>
          </div>
        </div>
      </div>
      <div class="info_info">
        <div class="info_text">产品详情</div>
        <div class="info_html" v-html="list.info"></div>
      </div>
    </div>
  </div>
</template>

<script>

import {coreProductList} from "@/views/mock";

export default {
  name: "coreProductInfo",
  data(){
    return{
      list:{},
    }
  },
  created(){
    let arr = coreProductList.flat().filter((item)=>{
      return item.id == this.$route.query.id
    })
    this.list = arr[0]
    // SEO：本页 TDK 由 src/utils/seo.js 的 DETAIL_SEO 按 ?id= 动态生成
    // （不要在这里写 document.title——路由守卫会在组件挂载后再写一次，会把这里覆盖掉）
  },
  methods:{
    black(){
      if(this.$route.query.fid){
        this.$router.push({ name: 'coreProduct', query: { fid: this.$route.query.fid } });
      }else {
        this.$router.push({ name: 'coreProduct', query: { fid: 0 } });
      }

    }
  }
}
</script>

<style scoped lang="scss">
.coreProductInfo{
  padding-bottom: 50px;
  .box_middle_list{
    display: flex;
    align-items: center;
    flex-direction: column;
    .core_top{
      width: 1200px;
      border-bottom: 2px solid rgb(227,227,227);
      text-align: right;
      padding: 14px 0;
    }
    .list_list{
      width: 1200px;
      margin-top: 30px;
      display: flex;
      .list_left{
        border: 1px solid rgb(217,217,217);
        height: max-content;
        padding: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        .list_left-img{
          width: 400px;
          height: 372px;
        }
        .imgInfo{
          position: absolute;
          left: 60px;
          top: 59px;
          width: 294px;
          height: 165px;

        }
      }
      .list_right{
        margin-left: 80px;
        width: 700px;
        .name{
          font-size: 24px;
        }
        .info{
          margin-top: 20px;
          font-size: 15px;

        }
      }
      .btn_list{
        display: flex;
        justify-content: space-between;
        margin-top: 50px;
        .phone{
          border: 1px solid rgb(63,170,249);
          width:250px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: rgb(63,170,249);
          border-radius: 4px;
          font-weight: bold;
          img{
            width: 22px;
            margin-right: 4px;
          }
        }
        .sub{
          padding: 16px 0;
          background: rgb(63,170,249);
          color: white;
          text-align: center;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 250px;
        }
      }
    }
    .info_info{
      width: 1200px;
      margin-top: 50px;
      border: 1px solid rgb(227,227,227);
      .info_text{
        border-top: 8px solid rgb(63,170,249);
        border-right: 1px solid rgb(227,227,227);
        padding: 10px 0;
        color: #2A5caa;
        width: 200px;
        text-align: center;
      }
      .info_html{
        border-top: 1px solid rgb(227,227,227);
        padding: 20px;
      }
    }
  }
}
</style>
